module.exports = __webpack_public_path__ + "static/media/aviation.93140137.svg";